<template xmlns="http://www.w3.org/1999/html">
    <main class="page-main">
        <article class="section-content static-page">

            <!-- Section content -->
            <div class="content-wrapper">
                <div class="content-inner">
                    <div class="content-thin">
                        <h1>{{$t('privacy')}}</h1>

                      <span v-html="$t('privacyPage.text')"></span>
                    </div>
                </div>
            </div>
            <!-- /Section content -->
        </article>

    </main>
</template>

<script>
    export default {
        name: "PrivacyPolicy",
        data(){
            return{
                web:   process.env.VUE_APP_WEB,
                phone: process.env.VUE_APP_CONTACT_PHONE,
                email: process.env.VUE_APP_CONTACT_EMAIL,
            }
        },
    }
</script>

<style scoped>
</style>
